// Tooltip.jsx
import React, { useState } from "react";
import ReactDOM from "react-dom";
import clsx from "clsx";

export const ToolTip = ({ content, children }) => {
  const [visible, setVisible] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });

  const handleMouseEnter = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    setPosition({
      x: rect.left + rect.width / 2,
      y: rect.top - 8, // slightly above
    });
    setVisible(true);
  };

  const handleMouseLeave = () => setVisible(false);

  return (
    <>
      {/* Icon or any child element */}
      <span
        className="relative inline-flex"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {children}
      </span>

      {visible &&
        ReactDOM.createPortal(
          <div
            className="fixed z-[9999] pointer-events-none"
            style={{
              top: position.y,
              left: position.x,
              transform: "translate(-50%, -100%)",
            }}
          >
            <div
              className={clsx(
                "relative bg-white text-primary-dark text-xs rounded-md px-2 py-1 shadow-lg",
                "transform transition-all duration-200 ease-out max-w-[200px] border border-gray-300",
                visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-2"
              )}
            >
              {content}

              <div className="absolute left-1/2 bottom-[-4px] -translate-x-1/2 w-2 h-2 bg-white rotate-45"></div>
            </div>
          </div>,
          document.body
        )}
    </>
  );
};
